import api from './api'
import type {
  AgentTemplate,
  AgentTemplateListResponse,
  CreateAgentFromTemplateRequest,
} from '@/schemas/agent-template'
import type { AgentCreateResponse } from './agent'
import type { AxiosRequestConfig } from 'axios'

export interface AgentTemplateListParams {
  category?: string
}

export const agentTemplateService = {
  // List all available templates
  async listTemplates(
    params?: AgentTemplateListParams,
    config?: AxiosRequestConfig
  ): Promise<AgentTemplateListResponse> {
    const response = await api.get<AgentTemplateListResponse>(
      '/agent-templates',
      { params, ...config }
    )
    return response.data
  },

  // Get a single template by ID
  async getTemplate(
    templateId: string,
    config?: AxiosRequestConfig
  ): Promise<AgentTemplate> {
    const response = await api.get<AgentTemplate>(
      `/agent-templates/${templateId}`,
      config
    )
    return response.data
  },

  // Get a single template by slug
  async getTemplateBySlug(
    slug: string,
    config?: AxiosRequestConfig
  ): Promise<AgentTemplate> {
    const response = await api.get<AgentTemplate>(
      `/agent-templates/slug/${slug}`,
      config
    )
    return response.data
  },

  // Create an agent from a template
  async createAgentFromTemplate(
    projectId: string,
    data: CreateAgentFromTemplateRequest,
    config?: AxiosRequestConfig
  ): Promise<AgentCreateResponse> {
    const response = await api.post<AgentCreateResponse>(
      `/projects/${projectId}/agents/from-template`,
      data,
      config
    )
    return response.data
  },
}
